import React, {Fragment, useState} from "react";
import DateFnsUtils from '@date-io/date-fns';
import {DateTimePicker, DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {IconButton, InputAdornment} from "@material-ui/core";
import {Calendar20} from "@carbon/icons-react"
import "./index.scss";


function BasicDateTimePicker(props) {
    const {textHelper, type = 'mmyy', date} = props;


    const [selectedDateFrom, handleDateChangeFrom] = useState(date?date:new Date());
    const [selectedDateTo, handleDateChangeTo] = useState(date?date:new Date());


    const newVal = (index) => {
        //alert(selectedDateFrom);
        //let retVal = index + 1;
        // 2. do calculations and send it to parent
        props.handleClick(selectedDateFrom);
    }
    return (
        <div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {(() => {
                    switch (type) {
                        case 'mm':
                            return <DatePicker
                                views={["year", "month"]}
                                label="Competency date"
                                helperText={textHelper}
                                variant="inline"
                                minDate={new Date("1950-12-30")}
                                maxDate={new Date("2030-12-30")}
                                value={selectedDateFrom}
                                onChange={handleDateChangeFrom}
                                onBlur={() => newVal(props.index)}
                                width={"100%"}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                <Calendar20/>
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />;
                        case 'yy':
                            return <DatePicker
                                views={["year"]}
                                label="Competency date"
                                helperText={textHelper}
                                variant="inline"
                                minDate={new Date("1950-12-30")}
                                maxDate={new Date("2030-12-30")}
                                value={selectedDateFrom}
                                onChange={handleDateChangeFrom}
                                onBlur={() => newVal(props.index)}
                                width={"100%"}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                <Calendar20/>
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />;
                        case 'mmyy-mmyy':
                            return <>
                                <DatePicker
                                    views={["year", "month"]}
                                    label="From"
                                    helperText={textHelper}
                                    variant="inline"
                                    minDate={new Date("1950-12-30")}
                                    maxDate={new Date("2030-12-30")}
                                    value={selectedDateFrom}
                                    onChange={handleDateChangeFrom}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <Calendar20/>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                <DatePicker
                                    views={["year", "month"]}
                                    label="To"
                                    helperText="    "
                                    variant="inline"
                                    minDate={selectedDateFrom}
                                    maxDate={new Date("2030-12-30")}
                                    value={selectedDateTo}
                                    onChange={handleDateChangeTo}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <Calendar20/>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </>;
                        default:
                            return <>
                                <DatePicker
                                    views={["year", "month"]}
                                    label="From"
                                    helperText={textHelper}
                                    variant="inline"
                                    minDate={new Date("1950-12-30")}
                                    maxDate={new Date("2030-12-30")}
                                    value={selectedDateFrom}
                                    onChange={handleDateChangeFrom}
                                    onBlur={() => (
                                        props.handledateFrom(selectedDateFrom)
                                    )}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <Calendar20/>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                <DatePicker
                                    views={["year", "month"]}
                                    label="To"
                                    helperText="    "
                                    variant="inline"
                                    minDate={selectedDateFrom}
                                    maxDate={new Date("2030-12-30")}
                                    value={selectedDateTo}
                                    onChange={handleDateChangeTo}
                                    onBlur={() => (
                                        props.handledateTo(selectedDateTo)
                                    )}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <Calendar20/>
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </>;
                    }
                })()}
            </MuiPickersUtilsProvider>
        </div>
    );
}

export default BasicDateTimePicker;
